import React from "react";
import PropTypes from "prop-types";
import { moneyToString } from "lib/money";

/**
 * Display an amount of money
 *
 * @param {string|number} [amount] optional, defaults to zero
 * @param {string} className will be added to outer element
 * @param {string} [symbol] optional, defaults to "£" (GBP)
 */
export default class Currency extends React.Component {
  
  static propTypes = {
    amount: PropTypes.number,
    className: PropTypes.string,
    symbol: PropTypes.string
  }
  
  static defaultProps = {
    amount: 0,
    symbol: "£"
  }
  
  /**
   * Split a monetary amount into its constituent parts as strings
   *
   * @param {number} moneyAmount
   * @returns {Object<String>} { moneyAmount, sign, unitAmount, fractionAmount }
   */
  static formatMoney(moneyAmount) {
    if (Number.isNaN(moneyAmount)) {
      // for NaN, return something pretty but meaningless
      return {
        moneyAmount,
        sign: "",
        unitAmount: "-",
        fractionAmount: "--"
      }
    } else {
      const amountString = moneyToString(Math.abs(moneyAmount));
      const [ unitAmount, fractionAmount ] = amountString.split(".");
      const isNegative = moneyAmount < 0;
      const sign = isNegative ? "-" : "";
      return { moneyAmount, sign, unitAmount, fractionAmount }
    }
  }
  
  render() {
    
    const { amount, className, symbol } = this.props;
    const money = Currency.formatMoney(amount);
    
    const classNames = [ "currency" ];
    if (className) {
      classNames.push(className);
    }
    
    // wrap each part separately for fine-grained styling control
    return (
      <span className={classNames.join(" ")}>
        <span className="currency__sign">{money.sign}</span>
        <span className="currency__symbol">{symbol}</span>
        <span className="currency__unit-amount">{money.unitAmount}</span>
        <span className="currency__decimal-point">.</span>
        <span className="currency__fraction-amount">{money.fractionAmount}</span>
      </span>
    );
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/Currency.js